import { render } from "./MeasuresGrid.vue?vue&type=template&id=3963aeb4&scoped=true"
import script from "./MeasuresGrid.vue?vue&type=script&lang=js"
export * from "./MeasuresGrid.vue?vue&type=script&lang=js"

import "./MeasuresGrid.vue?vue&type=style&index=0&id=3963aeb4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3963aeb4"]])

export default __exports__